import 'twin.macro';
import React from 'react';
import { Checkboxes } from 'components/Form/Checkboxes';
import FormGroup from 'components/Form/FormGroup';
import { useTranslation } from 'react-i18next';

interface Props {
  groups: string[];
  selectedGroups: string[];
  setSelectedGroups: (v: string[]) => void;
}

export function FilterGroupsEleves(props: Props) {
  const { setSelectedGroups, selectedGroups, groups } = props;
  const { t } = useTranslation(['eleve']);
  return (
    <FormGroup label={t('eleve:pyramide.filterByGroup')}>
      <Checkboxes
        tw="space-y-2"
        value={selectedGroups}
        onChange={v => setSelectedGroups(v)}
        options={groups.map(v => ({
          label: v,
          value: v,
        }))}
      />
    </FormGroup>
  );
}
